<template>
  <div class="page-container">
    <headerSection></headerSection>

    <!-- Hero Section -->
    <div class="hero-section">
      <div class="floating-ball ball-1"></div>
      <div class="floating-ball ball-2"></div>
      <div class="floating-ball ball-3"></div>

      <div class="container">
        <div class="hero-content">
          <div class="hero-icon-wrapper">
            <span class="hero-icon">📜</span>
          </div>
          <h1 class="title-glow">{{ $t('history_page.title') }}</h1>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container main-content">
      <!-- Loading State -->
      <div v-if="loading" class="loading-state">
        <div class="spinner-border text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="loading-text">{{ $t('loading') }}</p>
      </div>

      <!-- No Data State -->
      <div v-else-if="history.length === 0" class="no-data-state">
        <div class="no-data-container">
          <i class="fas fa-inbox fa-4x mb-3"></i>
          <h4 class="no-data-title">{{ $t('history_page.no_data') }}</h4>
          <p class="no-data-description">เมื่อคุณทำธุรกรรมแล้ว ประวัติจะแสดงที่นี่</p>
        </div>
      </div>

      <!-- Transaction Table with glassmorphism -->
      <div v-else class="transaction-container">
        <div class="table-responsive">
          <table class="modern-table">
            <thead>
              <tr>
                <th><i class="fas fa-calendar-alt mr-2"></i>{{ $t('history_page.title2') }}</th>
                <th><i class="fas fa-tag mr-2"></i>{{ $t('history_page.title3') }}</th>
                <th><i class="fas fa-coins mr-2"></i>{{ $t('history_page.title4') }}</th>
                <th><i class="fas fa-check-circle mr-2"></i>{{ $t('history_page.title5') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in history" :key="index" class="transaction-row">
                <td>{{ item.createdateShow }}</td>
                <td>
                  <span
                    class="type-badge"
                    :class="{
                      'badge-income': item.type === 'วงล้อ' || item.type === 'รูเล็ต' || item.type === 'ฝากต่อเนื่อง' || item.type === 'พันธมิตร' || item.type === 'คืนยอดเล่น',
                      'badge-withdraw': item.type === 'ถอน',
                      'badge-deposit': item.type === 'ฝาก'
                    }">
                    {{ item.type }}
                  </span>
                </td>
                <td class="amount">{{ numberWithCommas(item.qty) }}</td>
                <td>
                  <span
                    class="status-badge"
                    :class="{
                      'status-success': item.status === 'ดำเนินการแล้ว',
                      'status-pending': item.status !== 'ดำเนินการแล้ว' && item.status !== 'ยกเลิก',
                      'status-cancelled': item.status === 'ยกเลิก'
                    }">
                    <i
                      :class="{
                        'fas fa-check-circle': item.status === 'ดำเนินการแล้ว',
                        'fas fa-times-circle': item.status === 'ยกเลิก',
                        'fas fa-clock': item.status !== 'ดำเนินการแล้ว' && item.status !== 'ยกเลิก'
                      }"
                      class="mr-1"></i>
                    {{ getDisplayStatus(item.status) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
import _ from 'lodash'

export default {
  name: 'History',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  computed: {
    user() {
      return this.$store.state.user.user
    }
  },
  data() {
    return {
      history: [],
      loading: true
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    numberWithCommas(x) {
      if (!x) x = 0
      return Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getDisplayStatus(status) {
      if (status === 'ดำเนินการแล้ว' || status === 'ยกเลิก') {
        return status
      }
      return 'กำลังดำเนินการ'
    },
    getUserId() {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    }
  },
  async mounted() {
    this.scrollToTop()
    this.loading = true
    this.$store.commit('user/SET_LOADING', true)
    
    const user = this.getUserId()
    const history = []
    let lastdate = ''
    
    try {
    await firebase.firestore().collection('history').where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(500).get().then((snapshot) => {
      snapshot.forEach((doc) => {
        if (doc.data().qty) {
          const data = doc.data()
          data.key = doc.id
          data.createdateShow = moment(data.createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm')
          lastdate = data.createdate
          history.push(data)
        }
      })
    })
      
    await firebase.firestore().collection('spin').where('userkey', '==', user.key).where('createdate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
            type: (doc.data().game) ? doc.data().game : 'วงล้อ',
          createdate: doc.data().createdate,
          createdateShow: moment(doc.data().createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().value,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
      
    await firebase.firestore().collection('roulet').where('userkey', '==', user.key).where('createdate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'รูเล็ต',
          createdate: doc.data().createdate,
          createdateShow: moment(doc.data().createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().value,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
      
    await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'ฝากต่อเนื่อง',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
      
    await firebase.firestore().collection('partner_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'พันธมิตร',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
      
    await firebase.firestore().collection('cashback_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'คืนยอดเล่น',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })

    this.history = _.orderBy(history, ['createdate'], ['desc'])
    } catch (error) {
      console.error('Error loading history:', error)
    } finally {
      this.loading = false
    this.$store.commit('user/SET_LOADING', false)
    }
  }
}
</script>

<style scoped>
/* Page Container */
.page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #121612 0%, #0f2f12 50%, #121612 100%);
  padding-bottom: 100px;
  font-family: 'Kanit', sans-serif;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 80px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(30, 161, 66, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 0;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(144, 255, 60, 0.4));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  text-shadow:
    0 0 20px rgba(144, 255, 60, 0.5),
    0 0 40px rgba(30, 161, 66, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

/* Floating Balls */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #1ea142, #90ff3c);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #90ff3c, #1ea142);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #0f2f12, #1ea142);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* Main Content */
.main-content {
  padding: 40px 20px;
}

/* Loading State */
.loading-state {
  text-align: center;
  padding: 80px 20px;
}

.loading-text {
  color: #fff;
  margin-top: 20px;
  font-size: 16px;
}

/* No Data State */
.no-data-state {
  padding: 80px 20px;
  text-align: center;
}

.no-data-container {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(30, 161, 66, 0.2);
  border-radius: 12px;
  padding: 60px 40px;
  max-width: 500px;
  margin: 0 auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.no-data-container i {
  color: rgba(144, 255, 60, 0.5);
}

.no-data-title {
  color: #fff;
  font-size: 20px;
  margin-bottom: 10px;
}

.no-data-description {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

/* Transaction Container */
.transaction-container {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(30, 161, 66, 0.2);
  border-radius: 12px;
  overflow: hidden;
  margin: 0 0 40px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
}

.modern-table thead {
  background: rgba(30, 161, 66, 0.1);
}

.modern-table th {
  padding: 15px;
  text-align: left;
  color: #90ff3c;
  font-weight: 600;
  border-bottom: 1px solid rgba(30, 161, 66, 0.3);
}

.modern-table td {
  padding: 15px;
  color: #fff;
  border-bottom: 1px solid rgba(30, 161, 66, 0.1);
}

.transaction-row:hover {
  background: rgba(30, 161, 66, 0.05);
}

.transaction-row:last-child td {
  border-bottom: none;
}

.amount {
  font-weight: 600;
  color: #90ff3c;
}

.type-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 13px;
  font-weight: 600;
}

.badge-income {
  background: linear-gradient(135deg, #1ea142, #90ff3c);
  color: #000;
}

.badge-withdraw {
  background: linear-gradient(135deg, #fa709a, #fee140);
  color: #fff;
}

.badge-deposit {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  color: #fff;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 600;
}

.status-success {
  background: linear-gradient(135deg, #1ea142, #90ff3c);
  color: #000;
}

.status-pending {
  background: linear-gradient(135deg, #ffc107, #ff9800);
  color: #000;
}

.status-cancelled {
  background: linear-gradient(135deg, #f44336, #e91e63);
  color: #fff;
}

/* Tablet */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 25px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .modern-table th,
  .modern-table td {
    padding: 12px 8px;
    font-size: 14px;
  }

  .modern-table th i {
    display: none;
  }

  .type-badge {
    font-size: 11px;
    padding: 4px 8px;
  }

  .status-badge {
    font-size: 11px;
    padding: 4px 8px;
  }
}

/* Mobile */
@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .modern-table th,
  .modern-table td {
    padding: 10px 6px;
    font-size: 12px;
  }

  .type-badge {
    font-size: 10px;
    padding: 3px 6px;
  }

  .status-badge {
    font-size: 10px;
    padding: 3px 6px;
  }

  .status-badge i {
    display: none;
  }

  .no-data-container {
    padding: 40px 20px;
  }
}
</style>
